import { render, staticRenderFns } from "./BasicFilterCheckboxes.vue?vue&type=template&id=6a6ba0f8"
import script from "./BasicFilterCheckboxes.vue?vue&type=script&lang=js"
export * from "./BasicFilterCheckboxes.vue?vue&type=script&lang=js"
import style0 from "./BasicFilterCheckboxes.vue?vue&type=style&index=0&id=6a6ba0f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports